import React, { useState } from 'react';
import { motion } from 'motion/react';
import {
  Box,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Avatar,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import CloudTrailSidebar from './CloudTrailSidebar';

// Helper function to derive display name from email
const getDisplayNameFromEmail = (email) => {
  if (!email) return 'User';
  const localPart = email.split('@')[0];
  return localPart
    .replace(/[._-]/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

const CloudTrailLayout = ({ children, user }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleMobileToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', minHeight: '100vh' }}>
      {/* Mobile App Bar */}
      {isMobile && (
        <AppBar
          position="sticky"
          elevation={0}
          sx={{
            backgroundColor: '#FFFFFF',
            borderBottom: '1px solid #E5E5E5',
            zIndex: theme.zIndex.appBar,
          }}
        >
          <Toolbar sx={{ justifyContent: 'space-between', minHeight: '64px !important' }}>
            <IconButton
              onClick={handleMobileToggle}
              sx={{ color: '#253E66' }}
              edge="start"
            >
              <MenuIcon />
            </IconButton>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img
                src="https://www.cloudkeeper.com/themes/cloud_theme/images/Cloudkeeper_New.svg"
                alt="CloudKeeper"
                style={{
                  height: '22px',
                  width: 'auto',
                  objectFit: 'contain',
                }}
              />
              <Typography
                variant="caption"
                sx={{
                  color: '#4698D3',
                  fontFamily: 'Metropolis, sans-serif',
                  fontWeight: 600,
                  fontSize: '0.65rem',
                }}
              >
                CloudTrail
              </Typography>
            </Box>
            <Avatar
              sx={{
                width: 32,
                height: 32,
                backgroundColor: '#4698D3',
                fontFamily: 'Metropolis, sans-serif',
                fontWeight: 600,
                fontSize: '0.8rem',
              }}
            >
              {getDisplayNameFromEmail(user?.email).charAt(0).toUpperCase()}
            </Avatar>
          </Toolbar>
        </AppBar>
      )}

      <CloudTrailSidebar
        user={user}
        mobileOpen={mobileOpen}
        onMobileToggle={handleMobileToggle}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#F9FBFD',
          minHeight: isMobile ? 'auto' : '100vh',
          overflow: 'auto',
        }}
      >
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
          style={{ flexGrow: 1 }}
        >
          <Box sx={{ flexGrow: 1, p: { xs: 2, sm: 3 } }}>
            {children}
          </Box>
        </motion.div>
      </Box>
    </Box>
  );
};

export default CloudTrailLayout;
